import styled from "styled-components";
import bgImage from "../../assets/images/userdetailsimage.png"

export const Wrapper = styled.div`
  .banner-image {
    width: 100%;
    border-radius: 4px;
    height: 170px;
    object-position: bottom;
    object-fit: cover;
  }
  .user-image {
    position: relative;
    left: 25px;
    top: -45px;
    width: 128px;
    height: 128px;
    border-radius: 50%;
    object-fit: cover;
    background: white;
  }
  .user-name-text {
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    margin-top: 16px;
    margin-left: 6px;
    color: #182850;
  }
  .user-data-container {
    margin-left: 40px;
  }
  .vector-image {
    position: relative;
    top: -4px;
    height: 15%;
  }
  .user-address {
    color: #182850;
    padding-left: 5px;
    font-style: normal;
    font-size: 15px;
    font-weight: bold;
    letter-spacing: 1px;
    position: relative;
    top: -2px;
  }
  @media (max-width: 800px) {
    .user-image {
      left: 0px;
    }
    .location-container {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .image-col {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .user-data-container {
      width: 100%;
      margin-left: 0;
      margin-top: -39px;
      margin-bottom: 48px;
      max-width: 100%;
      flex: 0 0 100%;
      .user-name-text {
        text-align: center;
      }
    }
  }
`;

export const DesktopInfoWrapper = styled.div`

`;

export const UserinfoWrapper = styled.div`
  padding-bottom: 30px;
  
  .top-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    .image-container {
      display: flex;
      justify-content: center;
      align-items: center;
      background: #131f28;
      height: 150px;
      width: 150px;
      border-radius: 50%;
      position: relative;

      .image {
        height: 130px;
        width: 130px;
        border-radius: 50%;
        ${props => props.profile ? "border: 5px solid white;" : ""}
      }
      .edit-icon-container {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 0;
        right: 10px;
        background: #131f28;
        height: 28px;
        width: 28px;
        border-radius: 50%;
        
        .edit-icon {
          cursor: pointer;
        }
      }
    }
  }

  .content-container {
    background: #e8e8e8;
    padding: 15px;
    border-radius: 5px;
    margin-top: -30px;

    .content-display {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin: 30px 0;

      .title {
        font-size: 36px;
        font-weight: 600;
        text-transform: capitalize;
        color: #131f28;
      }

      .subtitle {
        font-size: 20px;
        font-weight: 600;
        color: #464646;
      }
    }

    .fields-container {
      margin-bottom: 30px;

      .card-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: white;
        box-shadow: 0 1px 15px #bcbcbc;
        padding: 10px;
        border-radius: 5px;
        min-height: 55px;

        .title {
          font-size: 14px;
          font-weight: 600;
        }
        .field {
          height: 100%; 

          .edit {
            display: flex;
            align-items: center;
            gap: 10px;
            .save {
              display: flex;
              flex-direction: column;
            }
          }

          .text {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 10px;
            padding: 5px;
            color: #969696;
            font-size: 13px;
          }

          .input {
            border: 1px solid #ccc;
            padding: 5px;
            border-radius: 5px;
            color: #969696;
            font-size: 13px;
          }
          .switch {
            padding: 5px;
          }
        }
      }
    }
  }

  .bottom-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 100px;
    margin-top: 50px;
    margin-bottom: 30px;

    .button {
      width: 300px;
      border-radius: 5px;
      font-weight: 600;
      font-size: 16px;
      letter-spacing: 1px;
    }

  }
  .ant-select-selection-item {
    color: #969696;
    font-size: 12px;
  }

  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border: none;
  }

`;

export const UserDetailsSmallScreenWrapper = styled.div`
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  position: relative;

  .top-bg-image {
    background-image: linear-gradient(rgba(0,0,0,0.5),rgba(0,0,0,0.5)), url(${bgImage});
    height: 25vh;
    background-attachment: fixed;
    background-position: center;
    background-size: center;
  }

  .user-details-container {
    height: 100%;
    background: white;
    margin-top: -20px;
    padding-bottom: 60px;
    border-top-right-radius: 25px;
    border-top-left-radius: 25px;
    position: relative;

    .floating-details{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 15px;

      .img-container {
        height: 100px;
        width: 100px;
        background: #131f28;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: -45px;
        
        img {
          height: 90px;
          width: 90px;
          border-radius: 50%;
        }
      }
      .username {
        font-size: 24px;
        font-weight: 600;
      }
    }
  }

`;

export const UserInfoSmallScreenWrapper = styled.div`
  margin: 0;
  padding: 15px;
  box-sizing: border-box;
  padding-bottom: 40px;

  .info-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    background: white;
    min-height: 60px;
    border-radius: 5px;
    box-shadow: 2px 1px 5px #c5c2c2;
    margin-top: 20px;

    .title {
      font-size: 14px;
      font-weight: 600;
    }

    .content {
      font-size: 14px;

      .select {
        padding: 0;

        select {
          border: none;
          outline: none;
        }
      }
    }
  }

  .btn-container {
    margin-top: 20px;
    padding: 10px;

    .reset-btn {
      border-radius: 8px;
      font-size: 16px;
      font-weight: 600;
    }
  }


  .setter-info-container {
    margin-top: 20px;
    border: none;
    border-radius: 4px;
  }
  
  .setter-info-container .title {
    font-weight: bold;
    margin-bottom: 5px;
  }
  
  .setter-info-container .content {
    margin-bottom: 10px;
    /* Add additional styling for the content if needed */
  }
  
  .setter-info-container .user-text {
    display: flex;
    align-items: center;
  }
  
  .setter-info-container .user-text input {
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
    width: 80px;    /* Add additional input styling if needed */
  }
  
  .setter-info-container .edit-cross-tick {
    color: #32aedb;
    margin-left: 5px;
    cursor: pointer;
  }

  .commission-info-container {
    margin-top: 20px;
    border: none;
    outline:none;
    border-radius: 4px;
  }
  
  .commission-info-container .title {
    font-weight: bold;
    margin-bottom: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .commission-info-container .user-text {
    display: flex;
    align-items: center;
    margin-top: 5px;
    border: none;
    outline: none;
    
  }

  .commission-info-container .Select {
    display: flex;
    align-items: center;
    margin-top: 5px;
    border: none;
    outline: none;
    
  }
  
  .commission-info-container .user-text label {
    margin-right: 10px;
    flex-shrink: 0;  
  }
  
  .commission-info-container .user-text select {
    width: 170px; /* Adjust the width as needed */
    padding: 0;
    border: none;
    outline: none;    
  }
  
  
  .commission-info-container .edit-cross-tick {
    color: #32aedb;
    margin-left: 5px;
    cursor: pointer;
  }
  

`